import { propsTypes } from '../types/sprite-types'


//画笔组件的可编辑属性
// key对应的是画笔的name，values对应需要修改的画笔的各个属性

export const ComponentProps = {
    "iframe": {
        name: '网页地址',
        values: {
            iframe: {
                label: '地址',
                type: propsTypes.string,
                value: ''
            }
        }
    },
    "input": {
        name: '输入框',
        values: {
            input: {
                label: '输入',
                type: propsTypes.string,
                value: ''
            }
        }
    },
    "svgPath": {
        name: 'SVG',
        values: {
            svgPath: {
                label: 'svg路径',
                type: propsTypes.string,
                value: ''
            }
        }
    },
    "radio": {
        name: '单选框',
        values: {
            direction: {
                label: '排列方向',
                type: propsTypes.eumn,
                value: 'vertical',
                options: [{
                    label: '水平',
                    value: 'horizontal'
                }, {
                    label: '垂直',
                    value: 'vertical'
                }]
            },
            checked: {
                label: '选中项',
                type: propsTypes.string,
                value: ''
            },
            optionInterval: {
                label: '垂直间距',
                type: propsTypes.number,
                value: 20
            },
            optionHeight: {
                label: '垂直高度',
                type: propsTypes.number,
                value: 20
            },
            options: {
                label: '选项值',
                type: propsTypes.json,
                value: []
            }
        }
    },
    "checkbox": {
        name: '复选框',
        values: {
            isForbidden: {
                label: '是否禁用',
                type: propsTypes.switch,
                value: false
            },
            checked: {
                label: '是否选中',
                type: propsTypes.switch,
                value: false
            },
            value: {
                label: '选项名',
                type: propsTypes.string,
                value: ''
            }
        }
    },
    switch: {
        name: "开关",
        values: {
            checked: {
                label: "是否打开",
                type: propsTypes.switch,
                value: false
            },
            offColor: {
                label: "关闭时背景颜色",
                type: propsTypes.color,
                value: ''
            },
            onColor: {
                label: "打开时背景颜色",
                type: propsTypes.color,
                value: ''
            },
            disable: {
                label: "是否禁用",
                type: propsTypes.switch,
                value: false
            },
            disableOffColor: {
                label: "关闭时禁用背景颜色",
                type: propsTypes.color,
                value: ''
            },
            disableOnColor: {
                label: "打开时禁用背景颜色",
                type: propsTypes.color,
                value: ''
            },
        }
    },
    slider: {
        name: '滑动输入',
        values: {
            barHeight: {
                label: "滑动条高度",
                type: propsTypes.number,
                value: ''
            },
            textWidth: {
                label: "文字区域宽度(靠右对齐)",
                type: propsTypes.number,
                value: ''
            },
            min: {
                label: "最小值",
                type: propsTypes.number,
                value: ''
            },
            max: {
                label: "最大值",
                type: propsTypes.number,
                value: ''
            },
            unit: {
                label: "单位",
                type: propsTypes.string,
                value: ''
            },
            value: {
                label: "当前值",
                type: propsTypes.number,
                value: ''
            }
        }
    },
    particle: {
        name: '粒子发射器',
        values: {
            distance: {
                label: "最大发射距离",
                type: propsTypes.number,
                value: 10
            },
            PRadius: {
                label: "粒子半径大小",
                type: propsTypes.number,
                value: 5
            },
            PEnable: {
                label: "启用/关闭",
                type: propsTypes.switch,
                value: true
            }
        }
    },
    echarts: {
        name: 'echarts',
        values: {
            echarts: {
                label: 'echarts配置',
                type: propsTypes.json,
                value: {}
            }
        }
    },
    AMapLibs: {
        name: '高德地图',
        values: {
            location: {
                label: '坐标',
                desc:'坐标以 , 逗号分隔',
                type: propsTypes.string,
                value: '116.397428,39.90923'
            },
            zoom:{
                label: '缩放级别',
                type: propsTypes.number,
                value: 12
            },
            city:{
                label: '城市',
                type: propsTypes.string,
                desc:'按照行政区名称或adcode来设置地图显示的中心点。\n行政区名称支持中国、省、市、区/县名称，如遇重名的情况，会按城市编码表顺序返回第一个。\n和坐标二选一，否则将默认使用城市坐标',
                value: ''
            }
        }
    },
    qrcode:{
        name:"二维码",
        values:{
            qrcodeText:{
                label:"二维码内容",
                type:propsTypes.string,
                value:""
            }
        }
    }
}